export default {"src":"/_next/static/media/0xdc301622e621166bd8e82f2ca0a26c13ad0be355.668df216.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};